import { yupResolver } from "@hookform/resolvers/yup";
import classnames from "classnames";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import {
  generateInputField,
  generateSelectField,
} from "helpers/form_helper_new";
import { formValidate } from "helpers/form_helper_old";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import {
  createBusinessUnit,
  detailBusinessUnit,
  listBusinessUnit,
  resetDetailBusinessUnit,
  resetUpdateBusinessUnit,
  updateBusinessUnit,
} from "store/actions";
import * as yup from "yup";
import { userModeList } from "./utils";

const DetailUser = props => {
  const {
    isOpenModal,
    dataDetail,
    toggleModal,
    mode,
    employeeList,
    userRoleList,
    userBusinessUnit,
  } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["businessUnit"]);
  const { addToast } = useToasts();

  const userManagement = useSelector(state => state.BusinessUnit);
  const {
    loadingDetail,
    errorDetail,
    detail: dataDetailBu,
    create: userCreate,
    loadingUpdate,
    errorUpdate,
    errorCreate,
    update: userUpdate,
  } = userManagement;

  const Dashboard = useSelector(state => state.Dashboard);
  const { listBuOfTenant } = Dashboard;

  const listBuOfTenantAllow = useMemo(() => {
    if (listBuOfTenant) {
      return listBuOfTenant
        ?.filter(f => f.value !== "ALL_BU")
        ?.map(b => {
          return {
            data: {
              ...b,
            },
            value: b.id,
            label: b.label,
          };
        });
    }
    return [];
  }, [listBuOfTenant, dataDetailBu]);

  const [activeTab, setactiveTab] = useState("1");
  const toggleTab = tab => {
    if (activeTab !== tab) {
      setactiveTab(tab);
    }
  };

  const [isDetail, setIsDetail] = useState(false); // Prevent To Set Data Again After Success Detail
  const initControlFields = {
    display: {
      code: false,
      mst: false,
      mccqt: false,
      dchi: false,
      ten: false,
      btn_save: false,
    },
  };

  const [controlFields, setControlFields] = useState(initControlFields);
  const history = useHistory();
  const schema = yup.object().shape({
    code: yup.string(),
    mst: yup
      .string()
      .test("len", "Vui lòng nhập 10 hoặc 14 ký tự", val => {
        return val.length === 0 || val.length === 10 || val.length === 14;
      })
      .nullable(),
    parent_id: yup.object().nullable(),
    dchi: yup.string().required("Vui lòng nhập địa chỉ"),
    ten: yup.string().required("Vui lòng nhập tên"),
    mccqt: yup
      .string()
      .test(
        "len",
        "Vui lòng nhập đủ 5 ký tự",
        val => val.length === 0 || val.length === 5
      ),
    sdthoai: yup.string(),
    dctdtu: yup.string(),
    send_mail: yup.boolean(),
    stknhang: yup.string(),
    tnhang: yup.string(),
    fax: yup.string(),
    website: yup.string(),

    invoice_type: yup
      .boolean()
      .nullable()
      .when("parent_id", {
        is: parent_id => {
          if (parent_id) {
            return true;
          } else {
            return false;
          }
        },
        then: yup.boolean().required(
          t("form.validate.select", {
            title: "Loại HĐ",
          })
        ),
      }),
    hdgtgt: yup.boolean().nullable(),
    hdbhang: yup.boolean().nullable(),
    ctu: yup.boolean().nullable(),

    decimal_place_foreign_currency: yup
      .number()
      .nullable()
      .transform(value => (isNaN(value) ? undefined : value))
      .required("Vui lòng nhập số"),
    drop_pdf: yup.boolean().nullable(),
    pending_van: yup.boolean().nullable(),
    direct_pos: yup.boolean().nullable(),
    can_pos: yup.boolean().nullable(),
    need_approve: yup.boolean().nullable(),
    is_release: yup.boolean().nullable(),
    group_cancel: yup.boolean().nullable(),

    type_sign_hsm: yup.boolean().nullable(),
    type_sign_usb_token: yup.boolean().nullable(),
    id_type_sign_hsm: yup.string().nullable(),
    id_type_sign_usb_token: yup.string().nullable(),
  });

  const {
    handleSubmit,
    reset,

    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,

    getValues,
    setError,
    register,

    unregister,
    watch,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      code: "",
      mst: "",
      parent_id: null,
      dchi: "",
      ten: "",
      mccqt: "",
      sdthoai: "",
      dctdtu: "",
      send_mail: 0,
      stknhang: "",
      tnhang: "",
      fax: "",
      website: "",

      invoice_type: 0,
      hdgtgt: 0,
      hdbhang: 0,
      ctu: 0,

      decimal_place_foreign_currency: 3,
      drop_pdf: 0,
      pending_van: 0,
      direct_pos: 0,
      can_pos: 0,
      need_approve: 1,
      is_release: 0,
      group_cancel: 0,
      type_sign_hsm: 0,
      id_type_sign_hsm: null,
      type_sign_usb_token: 0,
      id_type_sign_usb_token: null,
    },
  });

  const { parent_id, invoice_type } = watch();

  useEffect(() => {
    console.log("🚀 ~ file: Detail.js:125 ~ DetailUser ~ errors:", errors);
  }, [errors]);

  useEffect(() => {
    if (errorCreate) {
      if (errorCreate.code && errorCreate.code === 422) {
        addToast(
          "Đơn vị kinh doanh đã bị trùng, vui lòng thử lại đơn vị khác",
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        dispatch(resetUpdateBusinessUnit());
      }
    }
  }, [errorCreate]);
  useEffect(() => {
    if (!isOpenModal) {
      setactiveTab("1");
      dispatch(resetDetailBusinessUnit());
      setIsDetail(false);
      setControlFields(initControlFields);
    }
  }, [dispatch, isOpenModal]);

  // Action Detail
  useEffect(() => {
    if (isOpenModal) {
      if (dataDetail && dataDetail.userId && !isDetail) {
        dispatch(detailBusinessUnit(dataDetail.userId));
      }
    }
  }, [dataDetail, dispatch, isDetail, isOpenModal]);

  // Set Data Detail
  useEffect(() => {
    if (isOpenModal) {
      if (dataDetailBu && dataDetailBu.success && !isDetail) {
        let username = "";
        const defaultValues = {
          user_profile_id: undefined,
          user_role: [],
        };
        reset({});
        const dataReset = {};
        // START Thông tin cơ bản
        dataReset["code"] = dataDetailBu.code;
        dataReset["mst"] = dataDetailBu.mst;
        const buParent = listBuOfTenantAllow?.find(
          b => b.value === dataDetailBu.parent_id
        );
        setTimeout(() => {
          setValue("parent_id", buParent);
        });
        dataReset["dchi"] = dataDetailBu.dchi;
        dataReset["ten"] = dataDetailBu.ten;
        dataReset["mccqt"] = dataDetailBu.mccqt;
        dataReset["sdthoai"] = dataDetailBu.sdthoai;
        dataReset["dctdtu"] = dataDetailBu.dctdtu;
        dataReset["send_mail"] = dataDetailBu.send_mail;
        dataReset["stknhang"] = dataDetailBu.stknhang;
        dataReset["tnhang"] = dataDetailBu.tnhang;
        dataReset["fax"] = dataDetailBu.fax;
        dataReset["website"] = dataDetailBu.website;
        // END Thông tin cơ bản
        // START Cấu hình hóa đơn
        if (dataDetailBu.invoice_type !== null) {
          dataReset["invoice_type"] = String(dataDetailBu.invoice_type);
        }
        dataReset["hdgtgt"] = dataDetailBu.hdgtgt;
        dataReset["hdbhang"] = dataDetailBu.hdbhang;
        dataReset["ctu"] = dataDetailBu.ctu;

        dataReset["decimal_place_foreign_currency"] =
          dataDetailBu.decimal_place_foreign_currency;
        dataReset["drop_pdf"] = dataDetailBu.drop_pdf;
        dataReset["pending_van"] = dataDetailBu.pending_van;
        dataReset["direct_pos"] = dataDetailBu.direct_pos;
        dataReset["can_pos"] = dataDetailBu.can_pos;
        dataReset["need_approve"] = dataDetailBu.need_approve;
        dataReset["is_release"] = dataDetailBu.is_release;
        dataReset["group_cancel"] = dataDetailBu.group_cancel;

        dataReset["type_sign_hsm"] = dataDetailBu.type_sign_hsm;
        dataReset["type_sign_usb_token"] = dataDetailBu.type_sign_usb_token;
        dataReset["id_type_sign_hsm"] = dataDetailBu.id_type_sign_hsm;
        dataReset["id_type_sign_usb_token"] =
          dataDetailBu.id_type_sign_usb_token;
        // END Cấu hình hóa đơn
        console.log("🚀 ~ useEffect ~ dataDetailBu:", dataDetailBu);

        switch (mode) {
          case userModeList.VIEW_USER_DETAIL:
            reset({ ...defaultValues, ...dataReset });
            setControlFields({
              display: {
                ...initControlFields.display,
                user_profile_id: true,
                user_profile_phone: true,
                user_profile_name: true,
                user_profile_email: true,
                parent_id: true,
                user_login: true,
                user_role: true,
              },
            });
            break;
          case userModeList.EDIT_USER_DETAIL:
            reset({ ...defaultValues, ...dataReset });

            setControlFields({
              display: {
                ...initControlFields.display,
                user_profile_id: true,
                user_profile_phone: true,
                user_profile_name: true,
                user_profile_email: true,
                user_login: true,
                user_role: true,
                btn_save: true,
              },
            });
            break;
          default:
            break;
        }
        setIsDetail(true);
      } else {
        if (Object.keys(dataDetail).length === 0) {
          setControlFields({
            display: {
              ...initControlFields.display,
              user_profile_id: true,
              user_profile_phone: true,
              user_profile_name: true,
              user_profile_email: true,
              user_login: true,
              user_role: true,
              btn_save: true,
            },
          });
          setValue("code", "");
          setValue("mst", "");
          setValue("mccqt", "");
          setValue("dchi", "");
          setValue("ten", "");
          setValue("sdthoai", "");
          setValue("parent_id", "");
          setValue("dctdtu", "");

          setValue("send_mail", 0);

          setValue("drop_pdf", 0);

          setValue("pending_van", 0);

          setValue("direct_pos", 0);

          setValue("can_pos", 0);
          setValue("stknhang", "");
          setValue("tnhang", "");
          setValue("fax", "");
          setValue("website", "");
        }
      }
    }
  }, [isDetail, isOpenModal, mode, reset, setValue, dataDetailBu, dataDetail]);

  // Action Dispatch
  useEffect(() => {
    if (isOpenModal) {
      if (userUpdate && userUpdate.success) {
        addToast(t("form.submit.update.user.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(
          listBusinessUnit({
            ...(userBusinessUnit && userBusinessUnit.params),
            page: 1,
            sizePerPage: 10,
          })
        );
        dispatch(resetUpdateBusinessUnit());
        toggleModal(mode);
      }
    }
  }, [addToast, dispatch, isOpenModal, mode, t, userUpdate]);

  // Error Dispatch
  useEffect(() => {
    if (isOpenModal) {
      if (errorDetail && errorDetail.message) {
        addToast(errorDetail.message, {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetDetailBusinessUnit());
      }

      if (errorUpdate) {
        if (errorUpdate.code && errorUpdate.code === 422) {
          addToast(
            "Đơn vị kinh doanh đã bị trùng, vui lòng thử lại đơn vị khác",
            {
              appearance: "error",
              autoDismiss: true,
            }
          );
        }
        if (
          errorUpdate &&
          errorUpdate.fields &&
          errorUpdate.fields.length > 0
        ) {
          errorUpdate.fields.map(item => {
            let fieldName = item.field;
            switch (item.field) {
              case "usprofile_id":
                fieldName = "user_profile_id";
                break;
              case "username":
                fieldName = "user_login";
                break;
              case "roles":
                fieldName = "user_role";
                break;
              case "common":
                addToast(item.message, {
                  appearance: "error",
                  autoDismiss: true,
                });
                break;
              default:
                break;
            }
            setError(fieldName, { type: "manual", message: item.message });
          });
        }
        dispatch(resetUpdateBusinessUnit());
        if (errorUpdate.code !== 422) {
          toggleModal(mode);
        }
      }
    }
  }, [
    addToast,
    dispatch,
    errorDetail,
    errorUpdate,
    isOpenModal,
    mode,
    setError,
    toggleModal,
  ]);

  useEffect(() => {
    if (userCreate && userCreate.success) {
      addToast(t("form.submit.create.user.success"), {
        appearance: "success",
        autoDismiss: true,
      });
      dispatch(
        listBusinessUnit({
          ...(userBusinessUnit && userBusinessUnit.params),
          page: 1,
          sizePerPage: 10,
        })
      );
      dispatch(resetUpdateBusinessUnit());
      toggleModal(mode);
    }
  }, [addToast, dispatch, history, t, userCreate]);

  const onSubmit = values => {
    console.log("🚀 ~ onSubmit ~ values:", values);
    const { parent_id } = values;
    switch (mode) {
      case userModeList.EDIT_USER_DETAIL:
        if (Object.keys(dataDetail).length === 0) {
          dispatch(
            createBusinessUnit({
              code: values.code,
              mst: values.mst,
              mccqt: values.mccqt,
              dchi: values.dchi,
              ten: values.ten,
              sdthoai: values.sdthoai,
              parent_id: values.parent_id?.value || null,
              dctdtu: values.dctdtu,
              send_mail: values.send_mail ? 1 : 0,
              stknhang: values.stknhang,
              tnhang: values.tnhang,
              fax: values.fax,
              website: values.website,
              can_clone: 0,
              need_approve: values.need_approve ? 1 : 0,
              is_release: parent_id ? 0 : 1,
              group_cancel: values.group_cancel ? 1 : 0,
            })
          );
        } else {
          dispatch(
            updateBusinessUnit(dataDetailBu.id, {
              code: values.code,
              mst: values.mst,
              mccqt: values.mccqt,
              dchi: values.dchi,
              ten: values.ten,
              sdthoai: values.sdthoai,
              parent_id: values.parent_id?.value || null,
              dctdtu: values.dctdtu,
              send_mail: values.send_mail ? 1 : 0,
              drop_pdf: values.drop_pdf ? 1 : 0,
              pending_van: values.pending_van ? 1 : 0,
              direct_pos: values.direct_pos ? 1 : 0,
              can_pos: values.can_pos ? 1 : 0,
              need_approve: values.need_approve ? 1 : 0,
              is_release: values.is_release ? 1 : 0,
              group_cancel: values.group_cancel ? 1 : 0,
              type_sign_hsm: values.type_sign_hsm ? 1 : 0,
              type_sign_usb_token: values.type_sign_usb_token ? 1 : 0,
              id_type_sign_hsm: values.id_type_sign_hsm || null,
              id_type_sign_usb_token: values.id_type_sign_usb_token || null,
              stknhang: values.stknhang,
              tnhang: values.tnhang,
              fax: values.fax,
              website: values.website,

              invoice_type: parent_id
                ? values.invoice_type
                  ? 1
                  : 0
                : undefined,
              hdgtgt: parent_id ? (values.hdgtgt ? 1 : 0) : undefined,
              hdbhang: parent_id ? (values.hdbhang ? 1 : 0) : undefined,
              ctu: parent_id ? (values.ctu ? 1 : 0) : undefined,

              decimal_place_foreign_currency:
                values.decimal_place_foreign_currency,
              id_configurations: dataDetailBu.id_configurations,
            })
          );
        }

        break;
      default:
        break;
    }
  };

  return (
    <Modal
      size="lg"
      isOpen={isOpenModal}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggleModal}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggleModal}>
          {mode === userModeList.VIEW_USER_DETAIL && `${t("title.detail")}`}
          {mode === userModeList.EDIT_USER_DETAIL &&
          Object.keys(dataDetail).length === 0
            ? `${t("title.create")}`
            : controlFields.display.btn_save && `${t("title.edit")}`}
        </ModalHeader>
        {loadingDetail ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="8"
              countButton="2"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({
                      active: activeTab === "1",
                    })}
                    onClick={() => {
                      toggleTab("1");
                    }}
                  >
                    <i className="bx bx-chat font-size-20 d-sm-none" />
                    <span className="d-none d-sm-block text-primary">
                      Thông tin cơ bản
                    </span>
                  </NavLink>
                </NavItem>
                {dataDetail?.userId && (
                  <NavItem>
                    <NavLink
                      className={classnames({
                        active: activeTab === "2",
                      })}
                      onClick={() => {
                        toggleTab("2");
                      }}
                    >
                      <i className="bx bx-chat font-size-20 d-sm-none" />
                      <span className="d-none d-sm-block text-primary">
                        Cấu hình hóa đơn
                      </span>
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
              <TabContent activeTab={activeTab} className="py-2">
                <TabPane tabId="1">
                  <Form>
                    <Row className="row-cols-1 row-cols-md-2">
                      <Col>
                        <FormGroup className="mb-3">
                          <Label htmlFor="code">Mã</Label>
                          <input
                            disabled={mode === userModeList.VIEW_USER_DETAIL}
                            type="text"
                            className="form-control"
                            {...register("code")}
                          />
                        </FormGroup>
                      </Col>
                      {controlFields.display.user_profile_phone && (
                        <Col>
                          <FormGroup className="mb-3">
                            {generateInputField({
                              label: t("table.mst"),
                              isRequire: true,
                              isTaxCode: true,
                              inputType: "text",
                              errors: errors,
                              touched: touchedFields,
                              fieldName: "mst",
                              placeholder: t("placeholder.enter", {
                                title: t("table.mst"),
                              }),
                              register: register,
                              disabled: mode === userModeList.VIEW_USER_DETAIL,
                              control: control,
                              isShowLabel: true,
                              isClassCustomForm: false,
                            })}
                          </FormGroup>
                        </Col>
                      )}

                      <Col>
                        <FormGroup className="mb-3">
                          {generateSelectField({
                            label: t("form.parent_id"),
                            isRequire: false,
                            errors: errors,
                            fieldKey: "parent_id",
                            placeholder: t("placeholder.select", {
                              title: t("form.parent_id"),
                            }),
                            disabled: mode === userModeList.VIEW_USER_DETAIL,
                            control: control,
                            options: listBuOfTenantAllow,
                            menuPlacementSetting: "auto",
                            onChangeHandle: dataChange => {
                              if (dataChange) {
                                setValue("is_release", 0);
                              } else {
                                setValue("is_release", 1);
                              }
                              const mccqtParent = dataChange?.data?.mccqt || "";
                              const mstParent = dataChange?.data?.mst || "";
                              setValue("mccqt", mccqtParent);
                              if (mstParent) {
                                setValue("mst", mstParent);
                              }
                            },
                            isClassCustomForm: false,
                            // isLoading: false,
                            // allowCreate: item.allowCreate,
                            // widthLabel: item.widthLabel,
                            // extraComponent: extraComponent,
                            isClearable: true,
                          })}
                        </FormGroup>
                      </Col>
                      {controlFields.display.user_profile_email && (
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="dchi">
                              {t("table.dchi")}
                              <span className="text-danger"> (*)</span>
                            </Label>
                            <input
                              disabled={mode === userModeList.VIEW_USER_DETAIL}
                              type="text"
                              className="form-control"
                              {...register("dchi")}
                            />
                            {errors["dchi"] && (
                              <MessageFormValidate
                                error={errors["dchi"].message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                      )}
                      {controlFields.display.user_profile_email && (
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="ten">
                              {t("table.ten")}{" "}
                              <span className="text-danger"> (*)</span>{" "}
                            </Label>
                            <input
                              disabled={mode === userModeList.VIEW_USER_DETAIL}
                              type="text"
                              className="form-control"
                              {...register("ten")}
                            />
                            {errors["ten"] && (
                              <MessageFormValidate
                                error={errors["ten"].message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                      )}
                      {controlFields.display.user_profile_phone && (
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="mccqt">MCCQT</Label>
                            <input
                              disabled={
                                mode === userModeList.VIEW_USER_DETAIL ||
                                parent_id
                              }
                              type="text"
                              className={`form-control ${formValidate(
                                errors,
                                touchedFields,
                                "mccqt"
                              )}`}
                              {...register("mccqt")}
                            />
                            {errors["mccqt"] && (
                              <MessageFormValidate
                                error={errors["mccqt"].message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                      )}

                      {controlFields.display.user_profile_email && (
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="sdthoai">
                              {t("table.sdthoai")}
                            </Label>
                            <input
                              disabled={mode === userModeList.VIEW_USER_DETAIL}
                              type="text"
                              className="form-control"
                              {...register("sdthoai")}
                            />
                          </FormGroup>
                        </Col>
                      )}

                      {controlFields.display.user_profile_email && (
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="dctdtu">{t("table.dctdtu")}</Label>
                            <input
                              disabled={mode === userModeList.VIEW_USER_DETAIL}
                              type="text"
                              className="form-control"
                              {...register("dctdtu")}
                            />
                            <br></br>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <input
                                type="checkbox"
                                disabled={
                                  mode === userModeList.VIEW_USER_DETAIL
                                }
                                id="checkbox_sendmail"
                                className="custom-control-input checkbox-sendmail"
                                style={{
                                  width: "20px",
                                  height: "20px",
                                  marginTop: 0,
                                }}
                                {...register("send_mail")}
                              />
                              <label
                                style={{
                                  marginLeft: "10px",
                                  marginBottom: 0,
                                }}
                                htmlFor="checkbox_sendmail"
                              >
                                Gửi thông tin đến thư điện tử này
                              </label>
                            </div>
                          </FormGroup>
                        </Col>
                      )}

                      {controlFields.display.user_profile_email && (
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="stknhang">
                              {t("table.stknhang")}
                            </Label>
                            <input
                              disabled={mode === userModeList.VIEW_USER_DETAIL}
                              type="text"
                              className="form-control"
                              {...register("stknhang")}
                            />
                          </FormGroup>
                        </Col>
                      )}
                      {controlFields.display.user_profile_email && (
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="tnhang">{t("table.tnhang")}</Label>
                            <input
                              disabled={mode === userModeList.VIEW_USER_DETAIL}
                              type="text"
                              className="form-control"
                              {...register("tnhang")}
                            />
                          </FormGroup>
                        </Col>
                      )}
                      {controlFields.display.user_profile_email && (
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="fax">{t("table.fax")}</Label>
                            <input
                              disabled={mode === userModeList.VIEW_USER_DETAIL}
                              type="text"
                              className="form-control"
                              {...register("fax")}
                            />
                          </FormGroup>
                        </Col>
                      )}
                      {controlFields.display.user_profile_email && (
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="website">
                              {t("table.website")}
                            </Label>
                            <input
                              disabled={mode === userModeList.VIEW_USER_DETAIL}
                              type="text"
                              className="form-control"
                              {...register("website")}
                            />
                          </FormGroup>
                        </Col>
                      )}
                    </Row>
                  </Form>
                </TabPane>
                <TabPane tabId="2">
                  {/* {parent_id && ( */}
                  <>
                    <div className="mt-2 fw-bold text-primary">Loại HĐ:</div>
                    <Row>
                      <Label className="d-flex align-items-center gap-1">
                        <Controller
                          name="invoice_type"
                          control={control}
                          render={({ field }) => (
                            <input
                              type="radio"
                              {...field}
                              value={1}
                              checked={field.value === "1"}
                              onChange={e => {
                                field.onChange(e.target.value);
                              }}
                            />
                          )}
                        />
                        Có mã
                      </Label>
                      <Label className="d-flex align-items-center gap-1">
                        <Controller
                          name="invoice_type"
                          control={control}
                          render={({ field }) => (
                            <input
                              type="radio"
                              {...field}
                              value={0}
                              checked={field.value === "0"}
                              onChange={e => {
                                field.onChange(e.target.value);
                              }}
                            />
                          )}
                        />
                        Không mã
                      </Label>
                    </Row>
                    {errors.invoice_type && (
                      <MessageFormValidate
                        error={errors.invoice_type.message}
                      />
                    )}
                    <Row className="mt-2">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="checkbox"
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          id="checkbox_hdgtgt"
                          className="custom-control-input checkbox-hdgtgt"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginTop: 0,
                          }}
                          {...register("hdgtgt")}
                        />
                        <label
                          style={{
                            marginLeft: "10px",
                            marginBottom: 0,
                          }}
                          htmlFor="checkbox_hdgtgt"
                        >
                          Hóa đơn GTGT
                        </label>
                      </div>
                    </Row>{" "}
                    <Row className="mt-2">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="checkbox"
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          id="checkbox_hdbhang"
                          className="custom-control-input checkbox-hdbhang"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginTop: 0,
                          }}
                          {...register("hdbhang")}
                        />
                        <label
                          style={{
                            marginLeft: "10px",
                            marginBottom: 0,
                          }}
                          htmlFor="checkbox_hdbhang"
                        >
                          Hóa đơn bán hàng
                        </label>
                      </div>
                    </Row>
                    <Row className="mt-2">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="checkbox"
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          id="checkbox_ctu"
                          className="custom-control-input checkbox-ctu"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginTop: 0,
                          }}
                          {...register("ctu")}
                        />
                        <label
                          style={{
                            marginLeft: "10px",
                            marginBottom: 0,
                          }}
                          htmlFor="checkbox_ctu"
                        >
                          Hóa đơn chứng từ
                        </label>
                      </div>
                    </Row>
                    <hr />
                  </>
                  {/* )} */}

                  <div className="mt-2 fw-bold text-primary">Cấu hình:</div>
                  <Row>
                    <Col xs="6">
                      <FormGroup className="mb-3">
                        {generateInputField({
                          label:
                            "Làm tròn ngoại tệ (Khác VND) (đến n chữ số thập phân)",
                          isRequire: false,
                          inputType: "number",
                          errors: errors,
                          touched: touchedFields,
                          fieldName: "decimal_place_foreign_currency",
                          placeholder: t("placeholder.enter", {
                            title: t("table.decimal_place_foreign_currency"),
                          }),
                          register: register,
                          disabled: mode === userModeList.VIEW_USER_DETAIL,
                          control: control,
                          isShowLabel: true,
                          isClassCustomForm: false,
                        })}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        disabled={mode === userModeList.VIEW_USER_DETAIL}
                        id="checkbox_drop_pdf"
                        className="custom-control-input checkbox-drop_pdf"
                        style={{
                          width: "20px",
                          height: "20px",
                          marginTop: 0,
                        }}
                        {...register("drop_pdf")}
                      />
                      <label
                        style={{
                          marginLeft: "10px",
                          marginBottom: 0,
                        }}
                        htmlFor="checkbox_drop_pdf"
                      >
                        Cấu hình xuống dòng HHDV tại PDF (khi có ký hiệu #)
                      </label>
                    </div>
                  </Row>
                  <Row className="mt-2">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        disabled={mode === userModeList.VIEW_USER_DETAIL}
                        id="checkbox_pending_van"
                        className="custom-control-input checkbox-pending_van"
                        style={{
                          width: "20px",
                          height: "20px",
                          marginTop: 0,
                        }}
                        {...register("pending_van")}
                      />
                      <label
                        style={{
                          marginLeft: "10px",
                          marginBottom: 0,
                        }}
                        htmlFor="checkbox_pending_van"
                      >
                        Cấu hình ngăn Hóa Đơn gửi lên VAN
                      </label>
                    </div>
                  </Row>
                  <Row className="mt-2">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        disabled={mode === userModeList.VIEW_USER_DETAIL}
                        id="checkbox_direct_pos"
                        className="custom-control-input checkbox-direct_pos"
                        style={{
                          width: "20px",
                          height: "20px",
                          marginTop: 0,
                        }}
                        {...register("direct_pos")}
                      />
                      <label
                        style={{
                          marginLeft: "10px",
                          marginBottom: 0,
                        }}
                        htmlFor="checkbox_direct_pos"
                      >
                        Chuyển máy tính tiền trực tiếp
                      </label>
                    </div>
                  </Row>
                  <Row className="mt-2">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        disabled={mode === userModeList.VIEW_USER_DETAIL}
                        id="checkbox_can_pos"
                        className="custom-control-input checkbox-can_pos"
                        style={{
                          width: "20px",
                          height: "20px",
                          marginTop: 0,
                        }}
                        {...register("can_pos")}
                      />
                      <label
                        style={{
                          marginLeft: "10px",
                          marginBottom: 0,
                        }}
                        htmlFor="checkbox_can_pos"
                      >
                        Hiện menu Hóa đơn từ MTT
                      </label>
                    </div>
                  </Row>
                  <Row className="mt-2">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        disabled={mode === userModeList.VIEW_USER_DETAIL}
                        id="checkbox_need_approve"
                        className="custom-control-input checkbox-need_approve"
                        style={{
                          width: "20px",
                          height: "20px",
                          marginTop: 0,
                        }}
                        {...register("need_approve")}
                      />
                      <label
                        style={{
                          marginLeft: "10px",
                          marginBottom: 0,
                        }}
                        htmlFor="checkbox_need_approve"
                      >
                        Cần duyệt để phát hành
                      </label>
                    </div>
                  </Row>
                  <Row className="mt-2">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        disabled={mode === userModeList.VIEW_USER_DETAIL}
                        id="checkbox_is_release"
                        className="custom-control-input checkbox-is_release"
                        style={{
                          width: "20px",
                          height: "20px",
                          marginTop: 0,
                        }}
                        {...register("is_release")}
                      />
                      <label
                        style={{
                          marginLeft: "10px",
                          marginBottom: 0,
                        }}
                        htmlFor="checkbox_is_release"
                      >
                        Cho phép đơn vị tự phát hành (Không lấy thông tin theo
                        chi nhánh)
                      </label>
                    </div>
                  </Row>
                  <Row className="mt-2">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        disabled={mode === userModeList.VIEW_USER_DETAIL}
                        id="checkbox_group_cancel"
                        className="custom-control-input checkbox-group_cancel"
                        style={{
                          width: "20px",
                          height: "20px",
                          marginTop: 0,
                        }}
                        {...register("group_cancel")}
                      />
                      <label
                        style={{
                          marginLeft: "10px",
                          marginBottom: 0,
                        }}
                        htmlFor="checkbox_group_cancel"
                      >
                        Gom HĐ Hủy tự động
                      </label>
                    </div>
                  </Row>
                  <hr />
                  <>
                    <div className="mt-2 fw-bold text-primary">
                      Phương thức ký số:
                    </div>
                    <Row className="mt-2">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="checkbox"
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          id="checkbox_type_sign_hsm"
                          className="custom-control-input checkbox-type_sign_hsm"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginTop: 0,
                          }}
                          {...register("type_sign_hsm")}
                        />
                        <label
                          style={{
                            marginLeft: "10px",
                            marginBottom: 0,
                          }}
                          htmlFor="checkbox_type_sign_hsm"
                        >
                          Ký số HSM
                        </label>
                      </div>
                      <div
                        className="mt-1"
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="checkbox"
                          disabled={mode === userModeList.VIEW_USER_DETAIL}
                          id="checkbox_type_sign_usb_token"
                          className="custom-control-input checkbox-type_sign_usb_token"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginTop: 0,
                          }}
                          {...register("type_sign_usb_token")}
                        />
                        <label
                          style={{
                            marginLeft: "10px",
                            marginBottom: 0,
                          }}
                          htmlFor="checkbox_type_sign_usb_token"
                        >
                          Ký số bằng USB Token
                        </label>
                      </div>
                    </Row>
                  </>
                </TabPane>
              </TabContent>
            </ModalBody>
            <ModalFooter>
              <Row className="justify-content-end">
                {controlFields.display.btn_save && (
                  <Col className="col-auto">
                    <Button
                      color="primary"
                      className="btn-label"
                      type="button"
                      onClick={() => {
                        handleSubmit(onSubmit)();
                      }}
                      disabled={loadingUpdate}
                    >
                      <i className="bx bx-save label-icon"></i>
                      {t("form.save")}
                    </Button>
                  </Col>
                )}
              </Row>
            </ModalFooter>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

DetailUser.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  employeeList: PropTypes.object,
  userRoleList: PropTypes.object,
  userBusinessUnit: PropTypes.object,
};

DetailUser.defaultProps = {
  userBusinessUnit: {},
  isOpenModal: false,
  dataDetail: {},
  mode: "",
  employeeList: {},
  userRoleList: {},
};

export default DetailUser;
